// third party
import * as yup from 'yup';

// project imports
import { validationSchema as execSettingsValidationSchema } from 'store/app/workmgmt/exec-settings';
import { validationSchema as noteValidationSchema } from 'store/app/workmgmt/note';

const validationSchema = (intl, { requiresContacts = false } = {}) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        description: yup.string().nullable(),
        priority: yup.string().nullable(),
        responsible: yup
            .object()
            .shape({})
            .nullable()
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-responsible-required' })),
        participants: yup.array(yup.object().shape({}).nullable()).nullable(),
        contacts: yup
            .array()
            .of(yup.object().shape({}).nullable())
            .nullable()
            .test(
                'contacts-required',
                intl.formatMessage({ id: 'ui-comp-formvalidation-contacts-atleastone' }),
                (contacts) => !requiresContacts || (Array.isArray(contacts) && contacts.length > 0)
            ),
        execSettings: execSettingsValidationSchema(intl),
        notes: yup.array().of(noteValidationSchema(intl)).nullable(),
        tickets: yup.array().of(yup.object().shape({}).nullable()).nullable()
    });

export default validationSchema;
